(function () {
  'use strict';

  const SELECTOR = '.template-product .sk-product-benefits';
  const MOBILE = window.matchMedia('(max-width: 768px)');
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const AUTO_DELAY = 3600;
  const USER_DELAY = 7000;

  function initSlider(slider) {
    if (slider.dataset.skBenefitSlider === 'true') return;

    const slides = Array.from(slider.children).filter(function (element) {
      return element.classList.contains('sk-product-benefit');
    });

    if (slides.length < 2) return;

    let index = 0;
    let timer = 0;
    let scrollFrame = 0;
    let isVisible = true;
    const dots = document.createElement('div');
    const dotButtons = slides.map(function (_, slideIndex) {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'sk-product-benefits__dot';
      dot.setAttribute('aria-label', 'Show benefit ' + (slideIndex + 1));
      dot.setAttribute('data-sk-benefit-dot', String(slideIndex));
      dots.appendChild(dot);

      return dot;
    });

    slider.dataset.skBenefitSlider = 'true';
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-label', 'Shopping benefits');
    dots.className = 'sk-product-benefits__dots';
    dots.setAttribute('aria-label', 'Shopping benefit progress');
    slider.insertAdjacentElement('afterend', dots);

    slides.forEach(function (slide, slideIndex) {
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', (slideIndex + 1) + ' of ' + slides.length);
    });

    function stop() {
      window.clearTimeout(timer);
      timer = 0;
    }

    function updateDots() {
      dotButtons.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;

        dot.classList.toggle('is-active', active);

        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function canAutoPlay() {
      return MOBILE.matches && !REDUCED_MOTION.matches &&
        isVisible && !document.hidden;
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      updateDots();
      slider.scrollTo({
        left: index * slider.clientWidth,
        behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
      });
    }

    function schedule(delay) {
      stop();

      if (!canAutoPlay()) return;

      timer = window.setTimeout(function () {
        goTo(index + 1);
        schedule(AUTO_DELAY);
      }, delay || AUTO_DELAY);
    }

    function pauseForUser() {
      stop();
    }

    function resumeAfterUser() {
      if (slider.clientWidth) {
        index = Math.round(slider.scrollLeft / slider.clientWidth);
      }
      schedule(USER_DELAY);
    }

    slider.addEventListener('pointerdown', pauseForUser, { passive: true });
    slider.addEventListener('pointerup', resumeAfterUser, { passive: true });
    slider.addEventListener('touchend', resumeAfterUser, { passive: true });
    slider.addEventListener('focusin', pauseForUser);
    slider.addEventListener('focusout', resumeAfterUser);
    slider.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        if (!slider.clientWidth) return;
        index = Math.max(
          0,
          Math.min(slides.length - 1, Math.round(slider.scrollLeft / slider.clientWidth))
        );
        updateDots();
      });
    }, { passive: true });

    dotButtons.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        pauseForUser();
        goTo(dotIndex);
        schedule(USER_DELAY);
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else schedule(AUTO_DELAY);
    });

    MOBILE.addEventListener('change', function () {
      if (!MOBILE.matches) {
        stop();
        slider.scrollTo({ left: 0, behavior: 'auto' });
        index = 0;
      } else {
        goTo(index);
        schedule(AUTO_DELAY);
      }
    });

    REDUCED_MOTION.addEventListener('change', function () {
      schedule(AUTO_DELAY);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        isVisible = Boolean(entries[0] && entries[0].isIntersecting);
        if (isVisible) schedule(AUTO_DELAY);
        else stop();
      }, { threshold: 0.25 });

      observer.observe(slider);
    }

    updateDots();
    schedule(AUTO_DELAY);
  }

  function initializeAll() {
    document.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
